import React, { Fragment } from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Logo from '../assets/albert_logo.svg'
import Facebook from '../assets/group-3.svg'
import Insta from '../assets/group-2.svg'
import { logEvent, pushToDataLayer } from './Analytics'

class Footer extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop',
            buttomCss: ''
            
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
			if (window.innerWidth > 1000) {
				this.setState({ device: 'desktop'})
			} else {
				this.setState({ device: 'mobile'})
			}
		}
        window.addEventListener('scroll', this.handleScroll);
    }

    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    
    handleScroll =(event) => {
        let pageHeight = window.pageYOffset;
        if( pageHeight > 500)
        {
            this.setState({buttomCss: 'fixedButton'})
        }else{
            this.setState({buttomCss: ''})
        }
    }

    render(){
        const {footerbackground} = this.props.query;
        
        let customContainerMobile = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        }

        let mobileColumn = {
            width: '100%'
        }

        return(
            <Fragment>
                <div onScroll={e => this.handleScroll(e)}>
                    <footer>
                        <div className="custom-container">
                            <div className="col-md-3 col-sm-3 col-xs-6">
                                <h3>Albert</h3>
                                <ul>
                                    <li><Link to="/about" onClick={(e) => {
                                        logEvent(
                                        `Footer about us button`,
                                        `Footer about us button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer About Us Button',
                                            'Footer About Us Button Was Clicked'
                                        )
                                    }
                                    }>Om oss</Link></li>
                                    <li><Link to="/sponsring" onClick={(e) => {
                                        logEvent(
                                        `Footer sponsring us button`,
                                        `Footer sponsring us button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer Sponsring Us Button',
                                            'Footer Sponsring Us Button Was Clicked'
                                        )
                                    }}>CSR</Link></li>
                                    
                                </ul>
                            </div>
                            <div className="col-md-3 col-sm-3 col-xs-6">
                                <h3>Support</h3>
                                <ul>
                                    <li><Link to="/faq" onClick={(e) => {
                                        logEvent(
                                            `Footer faq button`,
                                            `Footer faq button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer FAQ Button',
                                            'Footer FAQ Button Was Clicked'
                                        )
                                        }}>Frågor & Svar</Link></li>
                                    <li><Link to="/contacts" onClick={(e) => {
                                        logEvent(
                                            `Footer contact us button`,
                                            `Footer contact us button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer Contact Us Button',
                                            'Footer Contact Us Button Was Clicked'
                                        )
                                        }}>Kontakta oss</Link></li>
                                </ul>
                            </div>
                            <div className="col-md-3 col-sm-3 col-xs-6">
                                <h3>Villkor</h3>
                                <ul>
                                    <li><Link to="/terms-and-conditions" onClick={(e) => {
                                        logEvent(
                                            `Footer term and condition button`,
                                            `Footer term and condition button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer Terms And Conditions Button',
                                            'Footer Terms And Conditions Button Was Clicked'
                                        )
                                        }}>Allmänna Villkor</Link></li>
                                    <li><Link to="/privacy" onClick={(e) => {
                                        logEvent(
                                            `Footer privacy button`,
                                            `Footer privacy button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer Privacy Button',
                                            'Footer Privacy Button Was Clicked'
                                        )
                                        }}>Integritetspolicy</Link></li>
                                    <li><Link to="/cookies" onClick={(e) => {
                                        logEvent(
                                            `Footer cookies button`,
                                            `Footer cookies button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Footer Cookies Button',
                                            'Footer Cookies Button Was Clicked'
                                        )
                                        }}>Cookiepolicy</Link></li>
                                </ul>
                            </div>
                            <div className="col-md-3 col-sm-3 col-xs-6">
                                <ul className='social-icon' style={this.state.device === 'mobile' ? {margin: 0} : null}>
                                    <li style={this.state.device === 'mobile' ? {margin: 0} : null}>
                                        <a href="https://www.facebook.com/hejalbert/" target="_blank" onClick={(e) => {
                                            logEvent(
                                            `Footer facebook button`,
                                            `Footer facebook button was clicked`
                                            )
                                            pushToDataLayer(
                                                'userClick',
                                                'Footer Facebook Button',
                                                'Footer Facebook Button Was Clicked'
                                            )
                                        }}><Facebook/></a>
                                    </li>
                                    <li style={this.state.device === 'mobile' ? {margin: 0} : null}>
                                        <a href="https://www.instagram.com/hej_albert/" target="_blank" onClick={(e) => {
                                            logEvent(
                                            `Footer instagram button`,
                                            `Footer instagram button was clicked`
                                            )
                                            pushToDataLayer(
                                                'userClick',
                                                'Footer Instagram Button',
                                                'Footer Instagram Button Was Clicked'
                                            )
                                        }}><Insta/></a>
                                    </li>
                                </ul>
                                <div className="image-foot">
                                <Logo style={{width: '100%', height: 'auto', maxWidth: '5rem'}}/>
                            </div>
                            </div>
                            
                            <div className="image-foot hidden-xs" style={this.state.device === 'mobile' ? {textAlign: 'center', margin: '1rem 0'} : null}>
                                <Logo style={{width: '100%', height: 'auto', maxWidth: '5rem'}}/>
                            </div>
                        <div className="copy-right">
                            <p>All Rights Reserved © eEducation Albert AB</p>
                        </div>
                        </div>
                        
                        
                    </footer>
                    <div className={`footer-fixed for-mobile ${this.state.buttomCss}`}>
                       <Link to="/register" className="prove">Bjud dina barn på läxhjälp</Link>
                    </div>
                    <div className="bg-black"></div>
                </div>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    footerbackground: file(relativePath: {regex: "/rectangle/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <Footer query={data} {...props}/>
        )}
    />
)